import { Box, Button, Typography } from '@wishket/design-system';

import { Illust, Link } from '@/shared/Components';

interface EmptyContentProps {
  title: string;
  description?: string;
  linkButtonName?: string;
  linkButtonUrl?: string;
}

const EmptyContent = ({
  title,
  description,
  linkButtonName,
  linkButtonUrl,
}: EmptyContentProps) => {
  return (
    <Box
      className="flex flex-col items-center justify-center gap-8"
      data-testid="feature--empty-content"
    >
      <Box className="flex flex-col items-center justify-center gap-2">
        <Box className="flex items-center justify-center px-[75px] py-[37px]">
          <Illust name="author" />
        </Box>
        <Box className="flex flex-col items-center justify-center gap-1.5">
          <Typography
            variant="subTitle1"
            className="font-medium text-w-gray-900"
          >
            {title}
          </Typography>
          {description && (
            <Typography variant="body1" className="text-w-gray-700">
              {description}
            </Typography>
          )}
        </Box>
      </Box>
      {linkButtonName && linkButtonUrl && (
        <Link href={linkButtonUrl} data-testid="empty-content--link-button">
          <Button variant="solid" className="w-[240px]">
            {linkButtonName}
          </Button>
        </Link>
      )}
    </Box>
  );
};

export default EmptyContent;
